<div class="PersonContact">
  <div class="row keep-top-far">
    <div class="col contact-field">
      <label for="presonContact">איש קשר</label>
      <input
        id="presonContact"
        class="form-control"
        (ngModelChange)="onChange($event)"
        [disabled]="isUserValidGetter"
        [(ngModel)]="personContact.contactPerson"
        type="text" />
    </div>
  </div>

  <div class="row keep-top-far">
    <div class="col contact-field">
      <label for="phoneContact">מספר טלפון</label>
      <div class="phone-row">
        <input
          type="text"
          [(ngModel)]="personContact.phoneNumber"
          (ngModelChange)="onChange($event)"
          id="phoneContact"
          class="form-control"
          [class.is-verified]="isUserValidGetter"
          phoneFormatter
          dir="ltr" />
        @if (!isUserValidGetter) {
          <button type="button" (click)="validatePhone()" class="form-control phoneValidate">אימות מספר</button>
        }
        @if (isUserValidGetter) {
          <div class="form-control phoneValidate verified-button" role="status">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1 3 5v6c0 5.6 3.8 10.7 9 12 5.2-1.3 9-6.4 9-12V5l-9-4zm-2 16-4-4 1.4-1.4L10 14.2l6.6-6.6L18 9l-8 8z"/></svg>
            מספר מאומת
          </div>
        }
      </div>
      @if (isUserValidGetter) {
        <div class="phone-status phone-status--ok">המספר אומת בהצלחה. שינוי המספר ידרוש אימות מחדש.</div>
      } @else if (personContact.phoneNumber) {
        <div class="phone-status">יש לאמת את המספר בקוד SMS כדי להמשיך לבחירת מסלול</div>
      }
    </div>
  </div>

  <div class="consent-list">
    <!-- SCRUM-168: the terms box unlocks only after reading the תקנון to the end. -->
    <label class="consent-option"
           [class.is-disabled]="termsAcceptedOnServer"
           [class.is-locked]="!termsRead && !personContact.acceptTerms"
           (click)="onTermsOptionClick($event)">
      <input
        class="consent-input"
        [disabled]="termsAcceptedOnServer || (!termsRead && !personContact.acceptTerms)"
        [ngModel]="personContact.acceptTerms"
        (ngModelChange)="onTermsChange($event)"
        type="checkbox" />
      <span class="consent-control" aria-hidden="true">
        <svg viewBox="0 0 20 20"><path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path></svg>
      </span>
      <span>קראתי ואישרתי את <a href="#" class="terms-link" (click)="openTerms($event)">התקנון</a></span>
    </label>
    @if (termsAcceptedOnServer && termsAcceptance) {
      <div class="consent-note consent-note--ok">
        התקנון (גרסה {{ termsAcceptance.termsVersion }}) אושר בתאריך {{ termsAcceptance.acceptedDate }} בשעה {{ termsAcceptance.acceptedTime }}
      </div>
    } @else if (!termsRead && !personContact.acceptTerms) {
      <div class="consent-note">יש לפתוח ולקרוא את התקנון עד סופו כדי לאשר אותו</div>
    }

    <!-- SCRUM-122 / SCRUM-168: optional opt-in, available only after the terms. -->
    <label class="consent-option" [class.is-disabled]="!personContact.acceptTerms">
      <input
        class="consent-input"
        [disabled]="!personContact.acceptTerms"
        [ngModel]="personContact.acceptAdv"
        (ngModelChange)="onAdvChange($event)"
        type="checkbox" />
      <span class="consent-control" aria-hidden="true">
        <svg viewBox="0 0 20 20"><path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path></svg>
      </span>
      <span>אני רוצה לקבל עדכונים רלוונטיים למודעה שלי במייל <small class="consent-optional">(לא חובה)</small></span>
    </label>
    @if (!personContact.acceptTerms) {
      <div class="consent-note">יש לאשר את התקנון תחילה</div>
    }

    @if (consentError) {
      <div class="consent-note consent-note--error" role="alert">{{ consentError }}</div>
    }
  </div>
</div>
